import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import moment from 'moment';
import DateRangePicker from 'react-bootstrap-daterangepicker';
import '../../../../stylesheets/daterangepicker.css';

import BlankState from '../../../../components/BlankState';
import StatusMessages2 from '../../../../components/StatusMessages2';
import Utils from '../../../../utils/mci-utils';

import { listBrokers, listPartners } from '../../../../actions/brokers';
import {
  saveCover,
  listCovers,
  updateCover
} from '../../../../actions/openCovers';

class AddOpenCover extends Component {
  constructor(props) {
    super(props);
    const { user } = this.props;

    this.state = {
      openCover: {},
      filter: {
        insurer: user.userInfo.insurer
      },
      errors: {}
    };
  }

  componentDidMount() {
    const { listPartners, listBrokers } = this.props;

    listBrokers(this.state.filter);
    listPartners(this.state.filter);
  }
  componentWillReceiveProps(nextProps) {
    this.setState({
      openCover: nextProps.editCover || {},
      updatedOpenCover: {
        id: nextProps.editCover ? nextProps.editCover.id : ''
      }
    });
  }

  onChange = e => {
    const { name, value } = e.target;
    const { openCover, updatedOpenCover } = this.state;

    this.setState({
      openCover: {
        ...openCover,
        [name]: value
      },
      updatedOpenCover: {
        ...updatedOpenCover,
        [name]: value
      }
    });
  };

  onSubmit = e => {
    e.preventDefault();
    const { openCover, updatedOpenCover } = this.state;

    if (updatedOpenCover.id) {
      this.props.updateCover(updatedOpenCover);
    } else {
      this.props.saveCover(openCover);
    }
  };

  render() {
    const { openCover } = this.state;
    const { covers } = this.props;
    const { partners } = this.props.brokers;
    let defaultStartDate = Utils.endOfYear();

    return (
      <form className="form form-horizontal" onSubmit={this.onSubmit}>
        <div className="col-sm-offset-4 col-sm-8">
          {covers.createCoverLoading ? (
            <BlankState
              data={false}
              customMessage="Saving details..."
              isDataLoading={covers.createCoverLoading}
            />
          ) : (
            <div>
              {covers.errorMessageCreateCover ? (
                <StatusMessages2
                  type="error"
                  message={
                    covers.errorMessageCreateCover !== undefined
                      ? covers.errorMessageCreateCover
                      : ''
                  }
                />
              ) : null}
              {covers.successCreateCover ? (
                <StatusMessages2 type="success" message="Details saved" />
              ) : null}
            </div>
          )}
        </div>

        <div className="form-group">
          <label className="col-sm-4 control-label">
            Company:
            <span className="text-danger">*</span>
          </label>
          <div className="col-sm-8">
            <select
              className="form-control"
              name="company"
              required
              onChange={this.onChange}
              value={openCover.company || ''}
            >
              <span className="help-block" />
              <option value="">Select a Company</option>
              {covers.companies.map((company, index) => {
                return (
                  <option key={index} value={company.id}>
                    {company.name}
                  </option>
                );
              })}
            </select>
          </div>
        </div>

        <div className="form-group">
          <label className="col-sm-4 control-label">
            Partner:
            <span className="text-danger">*</span>
          </label>
          <div className="col-sm-8">
            <select
              className="form-control"
              name="partnership"
              onChange={this.onChange}
              value={openCover.partnership || ''}
            >
              <span className="help-block" />
              <option value="">Select a Partner</option>
              {partners.map((partner, index) => {
                return (
                  <option key={index} value={partner.id}>
                    {partner.intermediary_name}
                  </option>
                );
              })}
            </select>
          </div>
        </div>

        <div className="form-group">
          <label className="col-sm-4 control-label">
            Upper Limit:
            <span className="text-danger">*</span>
          </label>
          <div className="col-sm-8">
            <input
              type="number"
              min="1"
              className="form-control"
              name="upper_limit"
              onChange={this.onChange}
              value={openCover.upper_limit || ''}
              required
            />
            <span className="help-block" />
          </div>
        </div>

        <div className="form-group">
          <label className="col-sm-4 control-label">
            Valid Until:
            <span className="text-danger">*</span>
          </label>
          <div className="col-sm-8">
            <DateRangePicker
              locale={{ format: 'YYYY-MM-DD hh:mm' }}
              minDate={moment()}
              singleDatePicker={true}
              startDate={defaultStartDate}
              onApply={e => {
                this.onChange(e);
              }}
            >
              <input
                name="valid_to"
                type="text"
                style={style}
                required
                className="form-control date-picker-control"
                placeholder="Start from date..."
                value={moment(openCover.valid_to).format('YYYY-MM-DD hh:mm')}
              />
            </DateRangePicker>
          </div>
        </div>

        <div className="form-group">
          <label className="col-sm-4 control-label">
            Policy Number:
            <span className="text-danger">*</span>
          </label>
          <div className="col-sm-8">
            <input
              type="text"
              className="form-control"
              name="policy_number"
              onChange={this.onChange}
              value={openCover.policy_number || ''}
              required
            />
            <span className="help-block" />
          </div>
        </div>

        <div className="form-group">
          <div className="col-sm-8 col-sm-offset-4">
            {openCover.hasOwnProperty('id') ? (
              <button type="submit" className="btn btn-warning">
                <i className="icon ion-checkmark" /> Edit Open Cover
              </button>
            ) : (
              <button type="submit" className="btn btn-success">
                <i className="icon ion-checkmark" /> Create Open Cover
              </button>
            )}
          </div>
        </div>
      </form>
    );
  }
}
const style = {
  width: '-webkit-fill-available'
};
const mapStateToProps = (state, ownProps) => ({
  covers: state.covers,
  user: state.user,
  brokers: state.brokers
});

const mapDispatchToProps = dispatch => {
  return bindActionCreators(
    { saveCover, updateCover, listPartners, listCovers, listBrokers },
    dispatch
  );
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(AddOpenCover);



// WEBPACK FOOTER //
// ./src/pages/dashboard/policies/open-covers/AddOpenCover.jsx